import { activeEditor$, ButtonWithTooltip, insertJsx$, JsxEditorProps, useCellValues, usePublisher } from "@mdxeditor/editor";
import { Edit, InsertChartOutlined } from "@mui/icons-material";
import { Box, Dialog, IconButton, Typography } from "@mui/material";
import { useState } from "react";
import { InsertChartPage } from "./insertChart";
import { ChartProps, GenericChart } from "../../graficos";

export const ChartEditor: React.ComponentType<JsxEditorProps> = (props) => {
  const insertJsx = usePublisher(insertJsx$);
  const [open, setOpen] = useState(false);
  const [editor] = useCellValues(activeEditor$);
  const editable = editor?.isEditable();
  const chartData = JSON.parse(props.mdastNode.attributes[0].value?.toString() ?? "{}") as ChartProps;

  const handleEdit = () => {
    setOpen(true);
  };
  const handleInsert = (chart: ChartProps) => {
    insertJsx({
      name: 'Chart',
      kind: 'flow',
      props: { chartData: JSON.stringify(chart) }
    });
    setOpen(false);
  };

  return <>
    <Chart
      open={open}
      startData={chartData}
      onInsert={handleInsert}
      onClose={() => setOpen(false)}
    />
    <Box sx={{
      width: "100%",
      display: "flex",
      flexDirection: "column",
      padding: "15px",
      border: editable ? "1px solid black" : undefined,
      borderRadius: "15px",
      alignItems: "center",
    }}>
      {editable &&
        <Box sx={{
          position: "relative",
          width: "100%",
        }}>
          <Box sx={{
            position: "absolute",
            top: "0px",
            right: "0px",
            border: "1px solid black",
            borderRadius: "5px",
            display: "flex",
            flexDirection: "row",
          }}>
            <IconButton onClick={handleEdit}><Edit /></IconButton>
          </Box>
        </Box>
      }
      <Typography fontWeight={"bold"} fontSize={18}>
        {chartData.title != "" ? (chartData.title ?? "Preview") : "Preview"}
      </Typography>

      <Box sx={{
        width: "100%",
        display: "flex",
        flexDirection: "column",
        padding: "15px",
        alignItems: chartData.position ?? "center",
      }}>
        <Box
          sx={{
            height: `${chartData.height}px`,
            width: `${chartData.width ?? 100}px`,
            border: "1px solid black"
          }}
        >
          <GenericChart {...chartData} />
        </Box>
      </Box>
    </Box>
  </>;
};

export const InsertChart = () => {
  const insertJsx = usePublisher(insertJsx$);
  const [open, setOpen] = useState(false);

  const handleInsert = (chart: ChartProps) => {
    insertJsx({
      name: 'Chart',
      kind: 'flow',
      props: { chartData: JSON.stringify(chart) }
    });
    setOpen(false);
  };

  return (
    <>
      <Chart
        open={open}
        onInsert={handleInsert}
        onClose={() => setOpen(false)}
      />
      <ButtonWithTooltip
        title="Insert Chart"
        onClick={() => setOpen(true)}
      >
        <InsertChartOutlined />
      </ButtonWithTooltip>
    </>
  );
};

interface ChartDataProps {
  open: boolean;
  startData?: ChartProps;
  onInsert?: (chart: ChartProps) => void;
  onClose?: () => void;
}
const Chart: React.FC<ChartDataProps> = (data) => {
  return <Dialog
    open={data.open}
    onClose={data.onClose}
    fullScreen={true}
    aria-labelledby="alert-dialog-title"
    aria-describedby="alert-dialog-description"
  >
    <InsertChartPage
      startData={data.startData}
      onClose={data.onClose}
      onInsert={data.onInsert}
    />
  </Dialog>;
};